var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IQOS',{attrs:{"required":"","title":_vm.$t('menu_content_type.title')}},[_c('BaseTabSwitcher',{staticClass:"w-100 mt-16",attrs:{"fullWidth":"","tabs":[
      {
        text: _vm.$t('menu_content_type.dishes'),
        value: 'dishes',
      },
      {
        text: _vm.$t('menu_content_type.drinks'),
        value: 'drinks',
      } ]},model:{value:(_vm.menuType),callback:function ($$v) {_vm.menuType=$$v},expression:"menuType"}}),_c('p',{staticClass:"mt-16 iqos-comment qrw-paragraph-md"},[_vm._v("\n    "+_vm._s(_vm.$t("menu_content_type.description"))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }